import React from "react";

const SvgBBiconsBmKonkurzyRestrukturalizace = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <style>
      {
        ".BBicons_BM-Konkurzy_restrukturalizace_svg__st4{display:none;fill:#6afff8}"
      }
    </style>
    <g id="BBicons_BM-Konkurzy_restrukturalizace_svg__Bo\u010Dn\xED_menu">
      <circle
        className="BBicons_BM-Konkurzy_restrukturalizace_svg__st4"
        cx={-120}
        cy={100}
        r={126.4}
      />
      <circle
        className="BBicons_BM-Konkurzy_restrukturalizace_svg__st4"
        cx={100}
        cy={100}
        r={126.4}
      />
      <g id="BBicons_BM-Konkurzy_restrukturalizace_svg__Konkurzy_a_restruturalizace">
        <path d="M36.1 21.6c-2.5 0-4.5 2-4.5 4.5V151h-7.2c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6l96 .1c-.8-2.3-1.4-4.7-1.8-7.2H112V73.3h32.2V107c2.9-1.2 5.9-2 9-2.5V68.7c0-2.5-2.1-4.5-4.5-4.5h-41.2c-2.5 0-4.5 2-4.5 4.5V151h-3.4V26.1c0-2.5-2-4.5-4.5-4.5h-59zm4.5 9h50V151H78.1v-25.3c0-1.3-.9-2.3-2.1-2.3H55.2c-1.2 0-2.2 1-2.2 2.3V151H40.6V30.6zm5.9 13.6c-1.6 0-2.9 1.5-2.9 3.5v.1c0 1.9 1.3 3.5 2.9 3.5H85c1.6 0 2.9-1.5 2.8-3.5v-.1c0-1.9-1.3-3.5-2.8-3.5H46.5zm0 24.2c-1.6 0-2.9 1.5-2.9 3.4v.1c0 1.9 1.3 3.5 2.9 3.5H85c1.6 0 2.9-1.5 2.8-3.5v-.1c0-1.9-1.3-3.4-2.8-3.4H46.5zm70.8 11.2c-1.5 0-2.6 1.6-2.6 3.5s1.2 3.5 2.6 3.5h21.8c1.5 0 2.7-1.6 2.7-3.5s-1.2-3.5-2.7-3.5h-21.8zM46.5 92.5c-1.6 0-2.9 1.6-2.9 3.5v.1c0 1.9 1.3 3.5 2.9 3.5H85c1.6 0 2.9-1.6 2.8-3.5V96c0-1.9-1.3-3.5-2.8-3.5H46.5zm70.8 5.7c-1.5 0-2.6 1.6-2.6 3.5s1.2 3.5 2.6 3.5h21.8c1.5 0 2.7-1.6 2.7-3.5s-1.2-3.5-2.7-3.5h-21.8zm0 18.6c-1.5 0-2.6 1.6-2.6 3.5s1.2 3.5 2.6 3.5h7.1c1.5-2.5 3.3-4.9 5.3-7h-12.4zm0 18.7c-1.5 0-2.6 1.6-2.6 3.5s1.2 3.5 2.6 3.5h1c.2-2.4.6-4.7 1.2-7h-2.2z" />
        <path d="M151.1 113.1c-14.5 3.7-24.5 16.6-24.5 32.1 0 18.4 14.9 33.3 33.3 33.3s33.3-14.9 33.3-33.3c0-15.4-10.1-28.1-24.9-31.7-1.4-.3-2.7.5-3.1 1.8-.1.2.1.4.1.6-.1 0-.1.1-.2.1l-1.4 9.1c-.1.9.6 1.7 1.5 1.6l5-.4-10.7 25.1 1.1-16.6c.1-.8-.7-1.5-1.5-1.5l-4.6.4-.2-18.2s-.1 0-.1-.1h-.1c0-.2.1-.3.1-.4-.4-1.4-1.7-2.3-3.1-1.9zm.5 5.1l.1 5.9c-.3 0-.6-.1-.9 0-8.6 3.4-13.8 11.4-13.8 21 0 12.7 10.3 23 22.9 23 12.7 0 22.9-10.3 22.9-23 0-7.9-3.2-14.3-9.3-18.4-.1-.1-.3 0-.5-.1l.6-1.4c.4-.9-.4-2-1.4-1.9l-5.6.5.8-5.3c12.3 3.2 20.6 13.7 20.6 26.6 0 15.6-12.6 28.2-28.2 28.2s-28.2-12.6-28.2-28.2c.1-12.8 8.1-23.5 20-26.9zm.1 11.2l.1 5.8c0 .8.7 1.4 1.5 1.3l4.5-.4-1.5 23c-.1 1.5 2 2 2.6.6l12.2-28.5c4.4 3.2 6.7 7.8 6.7 13.9 0 9.9-8 17.9-17.8 17.9-9.9 0-17.9-8-17.9-17.9-.1-7.2 3.6-12.9 9.6-15.7z" />
      </g>
      <circle
        className="BBicons_BM-Konkurzy_restrukturalizace_svg__st4"
        cx={320}
        cy={100}
        r={126.4}
      />
    </g>
  </svg>
);

export default SvgBBiconsBmKonkurzyRestrukturalizace;
